import img from '@shared/ui/images/blood2.webp';

export const Blood2Icon = () => {
    return <img src={img} alt="blood2" width="24px" />;
};
